import React, { FC, PropsWithChildren } from 'react';

import { useInitialisePosthog } from './useInitialisePosthog';
import { useInitialiseSentry } from './useInitialiseSentry';

export const InitialiseTracking: FC<PropsWithChildren> = ({ children }) => {
  useInitialisePosthog();
  useInitialiseSentry();

  return <>{children}</>;
};
